import type { TextChain } from '@/api/types/stowed-element'
import type { ShapeData } from '@/lib/shapes/types/shape-data'
import { debugBoundingBoxSignature } from '@/lib/shapes/debug-bounding-boxes'
import type { LinkableTextFrame } from '@/lib/text-linking/types/linkable-text-frame'

/**
 * The fingerprint `usePolledLinkingFrames` compares each frame; state is only set when it changes.
 *
 * Geometry, then the things that move a port without moving geometry: which frames are
 * linkable at all (`locked` gates the port render), their uids (what chains resolve against),
 * and the chain membership order itself.
 */
export function computeLinkingSignature({
  shapes,
  frames,
  overflowBadgeFrameIds,
  chains,
}: {
  shapes: ShapeData[]
  frames: LinkableTextFrame[]
  overflowBadgeFrameIds: ReadonlySet<string>
  chains: TextChain[]
}): string {
  let signature = debugBoundingBoxSignature(shapes)

  signature += '|'
  for (const f of frames) {
    signature += `${f.id}:${f.uid ?? ''}:${f.locked ? 1 : 0}:${
      overflowBadgeFrameIds.has(f.id) ? 1 : 0
    };`
  }

  signature += '|'
  for (const chain of chains) {
    signature += `${chain.textBox.map((t) => t.uid).join('>')};`
  }

  return signature
}
